import GearIcon from "@rsuite/icons/Gear";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Content,
  Dropdown,
  Header,
  Nav,
  Sidebar,
  Sidenav,
} from "rsuite";
import { BsCashCoin } from "react-icons/bs";
import { HiOutlineUser, HiOutlineUserGroup } from "react-icons/hi";
import { Route, Switch } from "react-router-dom";
import "./App.scss";
import MenuIcon from "@rsuite/icons/Menu";
import PageIcon from "@rsuite/icons/Page";
import {
  HiOutlineChartPie,
  HiOutlineLibrary,
  HiOutlineServer,
  HiOutlineTicket,
} from "react-icons/hi";
import { useRecoilState, useSetRecoilState } from "recoil";
import "../node_modules/react-vis/dist/style.css";
import { APi } from "./Api";
import { ENDPOINTS } from "./Api/enpoints";
import { agencyAtoms } from "./Atoms/agencies.atom";
import { agencyAtom } from "./Atoms/agency.atom";
import { isLogged } from "./Atoms/auth.atom";
import { CCAsAtom } from "./Atoms/cca.atom";
import { CurrencyAtom } from "./Atoms/currency.atom";
import { ExrciceAtom } from "./Atoms/exercice.atom";
import { OperationTypeAtom } from "./Atoms/operationTypes.atom";
import { PreferenceAtom } from "./Atoms/preference.atom";
import { respresentatAtom } from "./Atoms/representatives.atom";
import { TaxAtom } from "./Atoms/taxes.atom";
import { userAtom } from "./Atoms/user.atom";
import NotificationsList from "./Components/NotificationsList";
import { requestNotificationPermission } from "./notificationPermission";
import Login from "./Screens/Auth/login";
import Check from "./Screens/Check";
import CheckoutSummary from "./Screens/CheckoutSummary";
import JournalCheckout from "./Screens/JournalCheckout";
import Payment from "./Screens/Payment";
import ServiceTypes from "./Screens/ServiceType";
import CCA from "./Screens/Tiers/CCA";
import Client from "./Screens/Tiers/Client";
import Representative from "./Screens/Tiers/Representative";
import Transactions from "./Screens/Transactions";
import TransactionTypes from "./Screens/TransactionType";
import Bank from "./Screens/Treasory/Bank";
import Checkout from "./Screens/Treasory/Checkout";
import { voPacks } from "./Atoms/packsVo.atom";
import { umrahPacksVols } from "./Atoms/umrahPacks.atom";
import moment from "moment";
import { Minus } from "@rsuite/icons";
import { checkoutsAtom } from "./Atoms/checkouts.atom";
import Billings from "./Screens/Factures/Billings";
import DeliveryBand from "./Screens/DeliveryBand";
import CustomModal from "./Components/modal/customModal";
import LoginErp from "./Screens/AuthErp/loginErp";
import { transactions } from "./Atoms/transaction.atom";
import BalanceClient from "./Screens/Treasory/BalanceClients";
import TransactionsClients from "./Screens/Transactions/TransactionsClients";

const iconStyles = {
  width: 56,
  height: 56,
  padding: 18,
  lineHeight: "56px",
  textAlign: "center",
};

const App = (props) => {
  const navigate = useHistory();
  const currentLocation = navigate.location.pathname;
  const setexercices = useSetRecoilState(ExrciceAtom);
  const setcheckouts = useSetRecoilState(checkoutsAtom);
  const [expand, setExpand] = useState(false);
  const [loaded, setloaded] = useState(false);
  const [active, setActive] = useState(currentLocation);
  const [logged, setlogged] = useRecoilState(isLogged);
  const [pref, setpref] = useRecoilState(PreferenceAtom);
  const [user, setuser] = useRecoilState(userAtom);
  const setcurrencies = useSetRecoilState(CurrencyAtom);
  const setRepresentatives = useSetRecoilState(respresentatAtom);
  const setAgency = useSetRecoilState(agencyAtom);
  const setOperationTypes = useSetRecoilState(OperationTypeAtom);
  const setccas = useSetRecoilState(CCAsAtom);
  const setvoPacks = useSetRecoilState(voPacks);
  const setumrahPacksVols = useSetRecoilState(umrahPacksVols);
  const setTransaction = useSetRecoilState(transactions);
  const [pageTitle, setpageTitle] = useState("");
  const [agencies, setagencies] = useRecoilState(agencyAtoms);
  const [taxes, settaxes] = useRecoilState(TaxAtom);
  const tokenErp = localStorage.getItem("erp-token");
  const [modalState, setModalState] = useState({ open: false, loading: false });

  const handleClose = () => {
    setModalState((prev) => ({ ...prev, open: false }));

    if (!tokenErp) {
      navigate.push("/", { replace: true });
      setActive(1);
      setpageTitle("Transactions Caisses");
    }
  };

  const openModalIfNeeded = (path, name) => {
    if (!tokenErp) {
      setModalState({ ...modalState, open: true });
    } else {
      setpageTitle(name);
      setActive(path);
      navigate.push(path, { replace: true });
    }
  };
  useEffect(() => {
    requestNotificationPermission();
  }, []);

  const fetchAgencies = () => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Agency + "/getAll", {})
      .fetchAll()
      .then((res) => {
        setagencies(res.data);
      })
      .catch((e) => console.log(e.Message));
  };

  useEffect(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.PackageUmrah + "/getForPrices", {
      take: 10000,
    })
      .customGet()
      .then((res) => {
        let _vols = res.data.reduce(
          (a, b) =>
            a.concat(
              b.disponibilities.map((el) => ({
                value: el.id,
                label: (
                  <div style={{ color: "#232323" }}>
                    {moment(el.date).format("DD MMM YYYY")} (
                    <i style={{ color: "#999" }}>{b.name}</i>)
                  </div>
                ),
                locator:
                  moment(el.date).format("DD MMM YYYY") + " (" + b.name + ")",
              }))
            ),
          []
        );
        setumrahPacksVols(_vols);
      })
      .catch((e) => {});
  }, []);

  useEffect(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction, {
      service: 0,
      clientId: 0,
      representativeId: 0,
      checkoutId: user?.checkoutId,
      date: null,
      dateType: 0,
      status: 0,
      seasonId: 0,
    })
      .customGet()
      .then((res) => {
        const transactions = res.data.data.flatMap((transaction) => {
          return [
            {
              value: transaction.id,
              label: (
                <div style={{ color: "#232323" }}>
                  {transaction.serviceName.toUpperCase()} :{" "}
                  {transaction.disponibilityName || transaction.designation} (
                  <i style={{ color: "#999" }}>
                    {transaction?.infosB2C?.fullName || "-"}
                  </i>
                  )
                </div>
              ),
              montant: transaction.debit || transaction.credit,
            },
          ];
        });
        setTransaction(transactions);
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const fetchTaxes = () => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Tax + "/getAll", {})
      .fetchAll()
      .then((res) => {
        settaxes(res.data);
      })
      .catch((e) => console.log(e.Message));
  };
  const fetchsOperationTypes = () => {
    APi.createAPIEndpoint(ENDPOINTS.TransactionType)
      .fetchAll()
      .then((res) => setOperationTypes(res.data));
  };
  useEffect(() => {
    fetchsOperationTypes();
    APi.createAPIEndpoint(APi.ENDPOINTS.CCA + "/getAll", {})
      .fetchAll()
      .then((res) => {
        setccas(res.data);
      })
      .catch((e) => console.log(e.Message));
    fetchAgencies();
    fetchTaxes();
    APi.createAPIEndpoint(APi.ENDPOINTS.Currency, { page: 1, take: 1000 })
      .fetchAll()
      .then((res) => setcurrencies(res.data.data));
    APi.createAPIEndpoint(APi.ENDPOINTS.Representative, { page: 1, take: 1000 })
      .fetchAll()
      .then((res) =>
        setRepresentatives(
          res.data.data.map((el) => ({
            id: el.id,
            name: el.firstName + " " + el.lastName,
          }))
        )
      );
    let log = true;
    if (
      !localStorage.getItem("auth") ||
      !JSON.parse(localStorage.getItem("auth")).token
    ) {
      log = false;
    } else {
    }
    setlogged(log);
    setuser(JSON.parse(localStorage.getItem("auth")));
    setloaded(true);
    setpageTitle(routes[currentLocation]);
  }, [logged]);

  useEffect(() => {
    setExpand(false);
  }, [pageTitle]);

  const fetchCheckouts = (q = "") => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Checkout, { q, take: 100 })
      .customGet()
      .then((res) => setcheckouts(res.data.data));
  };
  useEffect(() => {
    fetchCheckouts();
    let _pref = localStorage.getItem("pref");
    if (_pref) setpref(JSON.parse(_pref));
  }, []);

  const AuthGard = (Screen) => (logged ? Screen : <Login />);

  return (
    <div className="app">
      <NotificationsList />

      <Container>
        {logged && (
          <Sidebar className={"app-sidebar " + (expand ? "show" : "")}>
            <Sidenav.Header>
              <div className="app-sidebar-header">
                <div>
                  <strong>
                    <BsCashCoin></BsCashCoin>
                  </strong>
                  <b
                    style={{
                      marginLeft: 12,
                      fontSize: "large",
                      textTransform: "uppercase",
                    }}
                  >
                    cashflow
                  </b>
                </div>
                <button
                  className="close_menu_btn"
                  onClick={(e) => setExpand((prev) => !prev)}
                >
                  x
                </button>
              </div>
            </Sidenav.Header>
            <Sidenav defaultOpenKeys={["1"]} appearance="subtle">
              <Sidenav.Body>
                <Nav>
                  {user && !user.checkoutId ? (
                    <>
                      <Nav.Item
                        onClick={() => {
                          setActive("/clients");
                          setpageTitle("Clients B2B");
                          navigate.push("/clients");
                        }}
                        active={currentLocation === "/clients"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineUserGroup />
                          </b>
                          <span className={"side_link"}>Clients B2B</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/tiers/cca");
                          setpageTitle("Comptes Superviseurs");
                          navigate.push("/tiers/cca");
                        }}
                        active={active === "/tiers/cca"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineUser />
                          </b>
                          <span className={"side_link "}>
                            Comptes Superviseurs
                          </span>
                        </div>
                      </Nav.Item>

                      <Nav.Item
                        onClick={() => {
                          setActive("/representatives");
                          setpageTitle("Représentants");
                          navigate.push("/representatives");
                        }}
                        active={active === "/representatives"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineUser />
                          </b>
                          <span className={"side_link "}>Représentants</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/banks");
                          setpageTitle("Banques");
                          navigate.push("/treasory/banks");
                        }}
                        active={active === "/treasory/banks"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineLibrary />
                          </b>
                          <span className={"side_link "}>Banques</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/settings/transaction_types");
                          setpageTitle("Types d'operations");
                          navigate.push("/settings/transaction_types");
                        }}
                        active={active === "/settings/transaction_types"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <GearIcon />
                          </b>
                          <span className={"side_link "}>
                            Types d'operations
                          </span>
                        </div>
                      </Nav.Item>
                      <hr></hr>
                    </>
                  ) : (
                    ""
                  )}

                  <Nav.Item
                    onClick={() => {
                      setActive("/checks");
                      setpageTitle("Gestion des chéques");
                      navigate.push("/checks");
                    }}
                    active={active === "/checks"}
                  >
                    <div className="side_link_menu">
                      <b>
                        <HiOutlineTicket />
                      </b>
                      <span className={"side_link "}>Gestion des chèques</span>
                    </div>
                  </Nav.Item>
                  <hr></hr>
                  {user && !user.checkoutId ? (
                    <>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/checkouts");
                          setpageTitle("Caisses");
                          navigate.push("/treasory/checkouts");
                        }}
                        active={active === "/treasory/checkouts"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineServer />
                          </b>
                          <span className={"side_link "}>Caisses</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/transactions");
                          setpageTitle("Transactions Caisses");
                          navigate.push("/treasory/transactions");
                        }}
                        active={
                          active === "/treasory/transactions" || active === "/"
                        }
                      >
                        <div className="side_link_menu">
                          <b>
                            <PageIcon />
                          </b>
                          <span className={"side_link "}>
                            Transactions Caisses
                          </span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/transactions_clients");
                          setpageTitle("Transactions clients");
                          navigate.push("/transactions_clients");
                        }}
                        active={active === "/transactions_clients"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineTicket />
                          </b>
                          <span className={"side_link "}>
                            Transactions Clients
                          </span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/balance_clients");
                          setpageTitle("Balance clients");
                          navigate.push("/balance_clients");
                        }}
                        active={active === "/balance_clients"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineTicket />
                          </b>
                          <span className={"side_link "}>Balance Clients</span>
                        </div>
                      </Nav.Item>
                    </>
                  ) : (
                    ""
                  )}

                  {user && user.checkoutId ? (
                    <>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/transactions_recettes");
                          setpageTitle("Caisse Recette");
                          navigate.push("/treasory/transactions_recettes");
                        }}
                        active={active === "/treasory/transactions_recettes"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <Minus />
                          </b>
                          <span className={"side_link "}>Caisse Recette</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/journal_checkout");
                          setpageTitle("Journal Caisse Recette");
                          navigate.push("/treasory/journal_checkout");
                        }}
                        active={active === "/treasory/journal_checkout"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <PageIcon />
                          </b>
                          <span className={"side_link "}>
                            Journal Caisse Recette
                          </span>
                        </div>
                      </Nav.Item>
                      <hr></hr>
                      {user.childCheckoutId ? (
                        <>
                          <Nav.Item
                            onClick={() => {
                              setActive("/treasory/transactions_expenses");
                              setpageTitle("Caisse Dépense");
                              navigate.push("/treasory/transactions_expenses");
                            }}
                            active={
                              active === "/treasory/transactions_expenses"
                            }
                          >
                            <div className="side_link_menu">
                              <b>
                                <Minus />
                              </b>
                              <span className={"side_link "}>
                                Caisse Dépense
                              </span>
                            </div>
                          </Nav.Item>
                          <Nav.Item
                            onClick={() => {
                              setActive("/treasory/journal_checkout_expenses");
                              setpageTitle("Journal Caisse Dépense");
                              navigate.push(
                                "/treasory/journal_checkout_expenses"
                              );
                            }}
                            active={
                              active === "/treasory/journal_checkout_expenses"
                            }
                          >
                            <div className="side_link_menu">
                              <b>
                                <PageIcon />
                              </b>
                              <span className={"side_link "}>
                                Journal Caisse Dépense
                              </span>
                            </div>
                          </Nav.Item>
                          <hr></hr>
                          <Nav.Item
                            onClick={() => {
                              setActive("/transactions_clients");
                              setpageTitle("Transactions clients");
                              navigate.push("/transactions_clients");
                            }}
                            active={active === "/transactions_clients"}
                          >
                            <div className="side_link_menu">
                              <b>
                                <HiOutlineTicket />
                              </b>
                              <span className={"side_link "}>
                                Transactions Clients
                              </span>
                            </div>
                          </Nav.Item>

                          <Nav.Item
                            onClick={() => {
                              setActive("/balance_clients");
                              setpageTitle("Balance clients");
                              navigate.push("/balance_clients");
                            }}
                            active={active === "/balance_clients"}
                          >
                            <div className="side_link_menu">
                              <b>
                                <HiOutlineTicket />
                              </b>
                              <span className={"side_link "}>
                                Balance Clients
                              </span>
                            </div>
                          </Nav.Item>
                          <hr></hr>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {user && !user.checkoutId ? (
                    <>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/journal_checkout");
                          setpageTitle("Journal Caisse");
                          navigate.push("/treasory/journal_checkout");
                        }}
                        active={active === "/treasory/journal_checkout"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <PageIcon />
                          </b>
                          <span className={"side_link "}>Journal Caisse</span>
                        </div>
                      </Nav.Item>
                      <Nav.Item
                        onClick={() => {
                          setActive("/treasory/checkout_summary");
                          setpageTitle("Recap. Caisses");
                          navigate.push("/treasory/checkout_summary");
                        }}
                        active={active === "/treasory/checkout_summary"}
                      >
                        <div className="side_link_menu">
                          <b>
                            <HiOutlineChartPie />
                          </b>
                          <span className={"side_link "}>Recap. Caisses</span>
                        </div>
                      </Nav.Item>
                      <hr></hr>
                      {tokenErp && (
                        <>
                          <Nav.Item
                            icon={
                              <b>
                                <PageIcon />
                              </b>
                            }
                            eventKey="BonsLivraison"
                            onClick={() => {
                              openModalIfNeeded(
                                "/bonsLivraison",
                                "Bons de Livraison"
                              );
                            }}
                            active={active == "BonsLivraison"}
                          >
                            <span className={"side_link "}>
                              Bons de Livraison
                            </span>
                          </Nav.Item>
                          <Nav.Item
                            icon={
                              <b>
                                <PageIcon />
                              </b>
                            }
                            eventKey="Factures"
                            onClick={() => {
                              openModalIfNeeded("/factures", "Factures"); // Check token and open modal if needed
                            }}
                            active={active == "Factures"}
                          >
                            <span className={"side_link "}>Factures</span>
                          </Nav.Item>
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {/* <Dropdown
                    trigger="hover"
                    title="Trésorerie"
                    icon={
                      <span className="side-span"></span>
                    }
                    placement="rightStart"
                  >
                    <Dropdown.Item
                      onClick={() => {
                        setActive("6-1");
                        setpageTitle("Banques");
                      }}
                      active={active === "6-1"}
                    >
                      <span className={"side_link "} to="/treasory/banks">
                        Banques
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setActive("6-2");
                        setpageTitle(" Caisses");
                      }}
                      active={active === "6-2"}
                    >
                      <span className={"side_link "} to="/treasory/checkouts">
                        Caisses
                      </span>
                    </Dropdown.Item>
                  </Dropdown> */}
                </Nav>
              </Sidenav.Body>
            </Sidenav>
            {/* <NavToggle expand={expand} onChange={() => setExpand(!expand)} /> */}
          </Sidebar>
        )}

        <Container className={"hole-container"}>
          {logged && (
            <Header className="page-header">
              <h4>{pageTitle}</h4>

              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <button
                  className="menu_btn"
                  onClick={(e) => setExpand((prev) => !prev)}
                  style={{
                    color: "#fff",
                    fontSize: "30px",
                    marginTop: "-12px",
                  }}
                >
                  <MenuIcon />
                </button>
                <Nav>
                  <Dropdown
                    placement="bottomEnd"
                    trigger="click"
                    icon={<GearIcon size="3em" />}
                    renderTitle={(children) => {
                      return <GearIcon style={iconStyles} />;
                    }}
                  >
                    {/* <Dropdown.Item>Help</Dropdown.Item>
                    <Dropdown.Item>Settings</Dropdown.Item> */}
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.removeItem("auth");
                        localStorage.removeItem("erp-token");
                        setlogged(false);
                        navigate.push("/");
                      }}
                    >
                      Sign out
                    </Dropdown.Item>
                    {!tokenErp && user.checkoutId === 0 && (
                      <Dropdown.Item
                        onClick={() => {
                          setModalState((prev) => ({ ...prev, open: true }));
                        }}
                      >
                        Connexion ERP
                      </Dropdown.Item>
                    )}
                  </Dropdown>
                </Nav>
              </div>
            </Header>
          )}

          <Content className={"app-content " + (!logged ? "" : "logged")}>
            {user && !user.checkoutId ? (
              <Switch>
                <Route
                  path="/clients"
                  render={(props) => AuthGard(<Client {...props} />)}
                />
                <Route
                  path="/tiers/cca"
                  render={(props) => AuthGard(<CCA {...props} />)}
                />
                <Route
                  path="/representatives"
                  render={(props) => AuthGard(<Representative {...props} />)}
                />
                <Route
                  path="/payments"
                  render={(props) => AuthGard(<Payment {...props} />)}
                />
                <Route
                  path="/treasory/banks"
                  render={(props) => AuthGard(<Bank {...props} />)}
                />
                <Route
                  path="/treasory/checkouts"
                  render={(props) => AuthGard(<Checkout {...props} />)}
                />
                <Route
                  path="/treasory/checkout_summary"
                  render={(props) => AuthGard(<CheckoutSummary {...props} />)}
                />
                <Route
                  path="/treasory/journal_checkout"
                  render={(props) => AuthGard(<JournalCheckout {...props} />)}
                />
                <Route
                  path="/service_type"
                  render={(props) => AuthGard(<ServiceTypes {...props} />)}
                />
                <Route
                  path="/checks"
                  render={(props) => AuthGard(<Check {...props} />)}
                />
                <Route
                  path="/settings/transaction_types"
                  render={(props) => AuthGard(<TransactionTypes {...props} />)}
                />
                <Route
                  path="/factures"
                  render={(props) => AuthGard(<Billings {...props} />)}
                />
                <Route
                  path="/bonsLivraison"
                  render={(props) => AuthGard(<DeliveryBand {...props} />)}
                />
                <Route
                  path="/balance_clients"
                  render={(props) => AuthGard(<BalanceClient {...props} />)}
                />
                <Route
                  path="/transactions_clients"
                  render={(props) =>
                    AuthGard(<TransactionsClients {...props} />)
                  }
                />
                <Route
                  path="/*"
                  render={(props) => AuthGard(<Transactions {...props} />)}
                />
              </Switch>
            ) : (
              <Switch>
                <Route
                  path="/checks"
                  render={(props) => AuthGard(<Check {...props} />)}
                />
                <Route
                  path="/treasory/transactions_recettes"
                  render={(props) =>
                    AuthGard(
                      <Transactions
                        checkoutId={user && user.checkoutId}
                        isExpense={false}
                        {...props}
                      ></Transactions>
                    )
                  }
                />

                <Route
                  path="/treasory/journal_checkout"
                  render={(props) =>
                    AuthGard(
                      <JournalCheckout
                        checkoutId={user && user.checkoutId}
                        {...props}
                      />
                    )
                  }
                />
                <Route
                  path="/treasory/transactions_expenses"
                  render={(props) =>
                    AuthGard(
                      <Transactions
                        checkoutId={user && user.childCheckoutId}
                        isExpense={true}
                        {...props}
                      />
                    )
                  }
                />
                <Route
                  path="/treasory/journal_checkout_expenses"
                  render={(props) =>
                    AuthGard(
                      <JournalCheckout
                        checkoutId={user && user.childCheckoutId}
                        {...props}
                      />
                    )
                  }
                />
                <Route
                  path="/transactions_clients"
                  render={(props) =>
                    AuthGard(
                      <TransactionsClients
                        checkoutId={user && user.checkoutId}
                        {...props}
                      />
                    )
                  }
                />
                <Route
                  path="/balance_clients"
                  render={(props) =>
                    AuthGard(
                      <BalanceClient
                        checkoutId={user && user.checkoutId}
                        {...props}
                      />
                    )
                  }
                />

                <Route
                  path="/*"
                  render={(props) =>
                    AuthGard(
                      <Transactions
                        checkoutId={user && user.checkoutId}
                        {...props}
                      />
                    )
                  }
                />
              </Switch>
            )}
          </Content>
        </Container>
      </Container>
      <style jsx>{`
        .side-span {
          padding: 10px;
        }
      `}</style>
      <CustomModal
        title="Login ERP"
        state={modalState}
        handleClose={handleClose}
        save={() => {}}
        footer={false}
      >
        <LoginErp closeModal={handleClose} />
      </CustomModal>
    </div>
  );
};

export default App;

const routes = {
  "/clients": "Clients B2B",
  "/tiers/cca": "Comptes Superviseurs",
  "/representatives": "Représentants",
  "/checks": "Gestion des chéques",
  "/treasory/banks": "Banques",
  "/treasory/checkouts": "Caisses",
  "/treasory/transactions": "Transactions Caisses",
  "/": "Transactions Caisses",
  "/treasory/checkout_summary": "Recap. Caisses",
  "/factures": "Factures",
  "/bonsLivraison": "Bons de Livraison",
  "/balance_clients": "Balance Clients",
  "/treasory/transactions_expenses": "Caisse Dépense",
  "/treasory/transactions_recettes": "Caisse Recette",
};
